import { Pipe, PipeTransform } from '@angular/core';

/**
 * The return value of this pipe should be used in the innerHTML prop.
 * @example
 * <div [innerHTML]="contentWithNewLines | withLineBreaks"></div>
 */
@Pipe({ name: 'withLineBreaks' })
export class WithLineBreaksPipe implements PipeTransform {
	transform(value: unknown): string {
		if (typeof value !== 'string') return '';
		return value.trim().replace(/\n/g, '<br/>');
	}
}
